import { css } from '@emotion/core';

import { SPACE_MINIMUM, spaceTopCozy } from '@/styles';

export const searchResultRowsStyles = css`
  & > li {
    padding: 12px 0;
  }
`;

export const cardContentStyles = css`
  ${spaceTopCozy};
  margin-bottom: ${SPACE_MINIMUM}px;
`;

export const starSpinnerStyles = css`
  @keyframes animName {
    0% {
      transform: rotate(0deg) scale(0.75);
    }
    50% {
      transform: rotate(180deg) scale(1);
    }
    100% {
      transform: rotate(360deg) scale(0.75);
    }
  }

  .star-spinner {
    animation: animName 2s linear infinite;
  }

  position: absolute;
  top: 4px;
  left: calc(50% - 95px);
`;
